import { Typography } from "@mui/material";

type Props = {
  length: number;
  max: number;
};

export function CharCounter({ length, max }: Props) {
  const atLimit = length >= max;
  return (
    <Typography
      variant="caption"
      data-at-limit={atLimit ? "true" : "false"}
      sx={{
        display: "block",
        textAlign: "right",
        mt: 0.5,
        color: atLimit ? "error.main" : "text.secondary",
        fontWeight: atLimit ? 600 : 400,
      }}
    >
      {length} / {max}
    </Typography>
  );
}
